// extracted by mini-css-extract-plugin
export default {"header":"styles_header__GDrpc","listing":"styles_listing__tnwpW"};